import { useQuery } from '@tanstack/react-query'

import { apiClient } from '../../apiClient'

type BaseMetrics = {
  total: number
  trend: number
}

type EngagementBreakdown = {
  breakdown: {
    timeSlice: string
    engagementsCount: number
  }[]
  summary: {
    bots: BaseMetrics
    engagements: BaseMetrics
  }
}

type ProgramsOverview = {
  id: string
  displayName: string
  icon?: string
  color?: string
  engagementsBreakdown: EngagementBreakdown
}

export type ProgramMineOverviewResponse = {
  programs: ProgramsOverview[]
}

export const PROGRAM_MINE_OVERVIEW_KEY = 'program-mine-overview'

export function useMine() {
  return useQuery({
    queryKey: [PROGRAM_MINE_OVERVIEW_KEY],
    queryFn: async () => {
      const { data } = await apiClient.get<ProgramMineOverviewResponse>(`int/v3/programs/mine/overview`)
      return data
    },
    select: (data) => ({
      ...data,
      programs: data.programs.sort((a, b) => a.displayName.localeCompare(b.displayName)),
    }),
  })
}
